export default "__VITE_ASSET__CMJ7PPD0__"